<template lang="pug">
div(v-if="ID")
  FlowEditor(:flow-aliases="aliases", :caseID="ID")
</template>

<script>
import FlowEditor from "@/components/FlowEditor";
import { mapGetters } from "vuex";

export default {
  name: "employer-case-profile",

  components: {
    FlowEditor,
  },

  data: () => ({
    aliases: [
      "case_free",
      "case_paid",
      "case_paid_key",
      "case_paid_officer",
      "case_paid_cos",
      "case_paid_lvl1",
    ],
  }),

  computed: {
    ...mapGetters("usercase", ["ID"]),
  },
};
</script>